var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classNames from 'classnames';
import Grid from './Grid';
import { GridContainerAside, GridContainerAsideContent } from './styles/gridAside.styled';
const GridAside = (_a) => {
    var { children, class: className, isSticky } = _a, attributes = __rest(_a, ["children", "class", "isSticky"]);
    const gridAsideClassNames = classNames('PONCHO-grid__aside', className);
    return (React.createElement(GridContainerAside, Object.assign({ className: gridAsideClassNames }, attributes),
        React.createElement(GridContainerAsideContent, { "$isSticky": isSticky },
            React.createElement(Grid, { columns: 1 }, children))));
};
GridAside.GRID_ELEMENT = 'GRID_ASIDE';
export default GridAside;
//# sourceMappingURL=GridAside.js.map